import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const badgeVariants = cva(
  'w-fit inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors',
  {
    variants: {
      variant: {
        default: 'border-gray-200 bg-gray-100 text-gray-600',
        primary: 'border-primary/15 bg-primary/10 text-primary',
        secondary: 'border-secondary/20 bg-secondary/15 text-gray-600',
        destructive: 'border-destructive/20 bg-destructive/10 text-destructive',
        success: 'border-green-200 bg-green-100 text-green-800',
        warning: 'border-amber-200 bg-amber-100 text-amber-900',
        info: 'border-purple-200 bg-purple-100 text-purple-900',
        outline: 'border text-foreground',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}

/* eslint-disable react-refresh/only-export-components -- badgeVariants is co-located for convenience */
export { Badge, badgeVariants };
